import {useContext, useEffect, useRef, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import './Chart.scss';
import {authContext} from '../Context/Authentication/authContext';

am4core.addLicense('CH332271218');

am4core.useTheme(am4themes_animated);

const getText = () => {
  return <div className='help-text'>
    <span style={{textDecoration: 'underline'}}>Helpful Hints:</span>
    <div className='char-list-items'>
      <ul>
        <li className='chart-list'>
          The plot shows population demographics of selected category for selected city.
        </li>
      </ul>
    </div>
  </div>
}

const ClusterChart = ({
                        chartData,
                        info,
                      }: any) => {
  const chartRef: any = useRef(null);


  const generateChart = () => {
    const chart = am4core.create('clusterChartDiv', am4charts.XYChart)
    chart.colors.step = 2;

    chart.legend = new am4charts.Legend()
    chart.legend.position = 'bottom'
    chart.legend.paddingTop = 20
    chart.legend.labels.template.maxWidth = 100

    // chart.legend.labels.template.class = 'your-legend-class';

    const xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
    xAxis.dataFields.category = 'date'
    xAxis.renderer.cellStartLocation = 0.1
    xAxis.renderer.cellEndLocation = 0.9
    xAxis.renderer.grid.template.location = 0;
    xAxis.renderer.minGridDistance = 30;

    

    chart.yAxes.push(new am4charts.ValueAxis());

    const createSeries = (value: any, name: any) => {
      const series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = value
      series.dataFields.categoryX = 'date'
      series.name = name
      series.columns.template.tooltipText = '[bold]{name}[/]: {valueY}';
      series.events.on('hidden', arrangeColumns);
      series.events.on('shown', arrangeColumns);
      return series;
    }
    console.log(chartData)
    const formattedChartData = chartData.map((data:any) => ({
      ...data,
      date: new Date(data.date).getFullYear().toString() // Extract year part from date string
    }));
    

    chart.data = formattedChartData

    const arrangeColumns = () => {
      const series = chart.series.getIndex(0);
      const w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
      // @ts-ignore
      if (series.dataItems.length > 1) {
        // @ts-ignore
        const x0 = xAxis.getX(series.dataItems.getIndex(0), 'categoryX');
        // @ts-ignore
        const x1 = xAxis.getX(series.dataItems.getIndex(1), 'categoryX');
        const delta = ((x1 - x0) / chart.series.length) * w;
        if (am4core.isNumber(delta)) {
          const middle = chart.series.length / 2;
          let newIndex = 0;
          chart.series.each((series: any) => {
            if (!series.isHidden && !series.isHiding) {
              series.dummyData = newIndex;
              newIndex++;
            } else {
              series.dummyData = chart.series.indexOf(series);
            }
          })
          const visibleCount = newIndex;
          const newMiddle = visibleCount / 2;

          chart.series.each((series: any) => {
            const trueIndex = chart.series.indexOf(series);
            const newIndex = series.dummyData;
            const dx = (newIndex - trueIndex + middle - newMiddle) * delta

            series.animate({property: 'dx', to: dx}, series.interpolationDuration, series.interpolationEasing);
            series.bulletsContainer.animate({
              property: 'dx',
              to: dx
            }, series.interpolationDuration, series.interpolationEasing);
          })
        }
      }
    }

    console.log(info)
    info.forEach((i: string) => {
      createSeries(i, i);
    })
    return chart
  }


  useEffect(() => {
    chartRef.current = generateChart()
    return () => {
      chartRef.current && chartRef.current?.dispose();
    };
  }, [chartData]);

  return (
    <>
      <div className='chart-main'>
        <div
          className='chart-main__clusterAreaChart'
          id={'clusterChartDiv'}
          ref={chartRef}
        ></div>
      </div>
      <div className='chart-main__predictedValueText'>
        {getText()}
      </div>

    </>
  );
};

export default ClusterChart;
